// ======================================================================
// File Name       : ServiceLoginList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Table, Col, FormControl } from 'react-bootstrap';

import TableHead, { setSortState } from '../components/TableHead';
import PaginationCustom from '../components/Pagination';

class ServiceLoginList extends React.Component {
  constructor() {
    super();
    this.handleServiceChange = this.handleServiceChange.bind(this);
  }
  /**
   * Handle when select on radio button
   * @param {*} e
   */
  handleServiceChange(e) {
    const value = e.target.value;
    this.props.onHandleSelectService(e);
  }

  render() {
    let serviceList = null;
    const { enterpriseName, serviceSearchInfo } = this.props;
    if (this.props.serviceInfo.recordNum > 0) {
      serviceList = this.props.serviceInfo.serviceList.map((service, index) => (
        <tr key={index} name="serviceCd" className="cursor_pointer">
          <td width={50}>
            <Form.Group
              controlId={service.serviceCd}
              className="margin-bottom-0"
            >
              <Form.Check
                type='radio'
                name="serviceCd"
                id={service.serviceCd}
                className="text-center"
                value={service.serviceCd}
                onChange={this.handleServiceChange}
                checked={service.serviceCd === serviceSearchInfo.serviceCd} />
            </Form.Group>
          </td>
          <td>
            <label
              className="form-label"
              htmlFor={service.serviceCd}
              className="cursor_pointer displayBlock padding-top-bottom-clear"
            >
              {service.serviceName}
            </label>
          </td>
          <td>
            <label
              className="form-label"
              htmlFor={service.serviceCd}
              className="cursor_pointer displayBlock padding-top-bottom-clear"
            >
              {enterpriseName}
            </label>
          </td>
        </tr>
      ));
    }

    // table head
    const thead = [
      { title: '', sortBy: null, width: 50 },
      { title: 'サービス名', sortBy: 2 },
      { title: '企業名', sortBy: 3 },
    ];
    let data = thead;
    if (serviceSearchInfo) {
      const sortBy = serviceSearchInfo.serviceSortType;
      const sortState = serviceSearchInfo.ascendingDescendingSort;
      data = setSortState(thead, sortBy, sortState);
    }
    return (
      <Col sm={12} className="padding-left-right-clear margin-top-30">
        <Table striped hover>
          <thead>
            <TableHead data={data} handleSortState={this.props.onHandleSortState} />
          </thead>
          <tbody>{serviceList}</tbody>
        </Table>
        <Col className="d-flex justify-content-center margin-bottom-30">
          <PaginationCustom
            recordNum={this.props.serviceInfo.recordNum}
            handlePageSelect={this.props.onHandlePaginationChange}
            startPosition={this.props.startPosition}
          />
        </Col>
      </Col>
    );
  }
}

export default ServiceLoginList;
